import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import UnallocateIcon from 'material-ui/svg-icons/action/assignment-return';
import AutoAllocateIcon from 'material-ui/svg-icons/action/assignment';
import AutoAllocateIndicator from '../../../containers/DailyPlanning/AutoAllocate/AutoAllocateIndicatorContainer';
import DropdownWrapper from '../../common/DropdownWrapper/DropdownWrapper';
import SelectableList from '../../common/SelectableList/SelectableList';
import { options as sortingOptions } from '../../../settings/constants/sorting';
import { raisedButtonStyle } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';
import Spinner from '../../common/Spinner/Spinner';
import { lowerFirstLetter } from '../../../utils/helpers';
import { autoAllocationStatuses } from '../../../settings/constants';
import ConfirmationDialog from '../../common/ConfirmationDialog/ConfirmationDialog';
import { addDaysToDate } from '../../../utils/datetimeconverter';

const locale = globals.getArea('dailyPlanning');
const iconSize = 21;
const styles = {
  teamName: { textAlign: 'center', width: '100%' },
  button: { width: iconSize, height: iconSize },
  sorting: ['icon-sort-ascending icon-xsmall', 'icon-sort-descending icon-xsmall'],
};
const autoAllocateButton = <AutoAllocateIcon style={styles.button} />;
const autoUnallocateButton = <UnallocateIcon style={styles.button} />;

class TreatmentFilterBox extends React.Component {
  state = { showClearAllocationsConfirmation: false };

  componentDidMount() {
    this.startUpdates(30000);
  }

  componentWillReceiveProps(prevProps) {
    if (this.props.syncProgress !== prevProps.syncProgress && this.props.syncProgress === 100) {
      this.props.refreshScheduler();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.autoAllocate !== nextProps.autoAllocate ||
      this.props.autoUnallocate !== nextProps.autoUnallocate ||
      this.props.selectedDate !== nextProps.selectedDate ||
      this.props.selectedTeam !== nextProps.selectedTeam ||
      this.props.autoAllocationProgress !== nextProps.autoAllocationProgress ||
      this.props.autoAllocationStatus !== nextProps.autoAllocationStatus ||
      this.props.isUnAllocating !== nextProps.isUnAllocating ||
      this.props.autoAllocationTeamName !== nextProps.autoAllocationTeamName ||
      this.props.autoAllocateTeamId !== nextProps.autoAllocateTeamId ||
      this.props.autoAllocateDate !== nextProps.autoAllocateDate ||
      this.props.serverDateTime !== nextProps.serverDateTime ||
      this.props.createAutoAllocationLog !== nextProps.createAutoAllocationLog ||
      this.state.showClearAllocationsConfirmation !== nextState.showClearAllocationsConfirmation
    );
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  getSelectedTeamOption = () => [
    {
      index: this.props.teams.findIndex(el => el.id === this.props.selectedTeam),
    },
  ];

  getSelectedSortingOption = () => [
    {
      index: sortingOptions.findIndex(el => el === this.props.sorting.orderBy),
      clickedBefore: this.props.sorting.orderDir !== 'asc',
    },
  ];

  unallocate = () =>
    this.setState({
      showClearAllocationsConfirmation: true,
    });

  selectItem = selectedItems => this.props.updateFilters({ selectedTeam: selectedItems[0].id });

  autoAllocate = () =>
    this.props.autoAllocate({
      date: this.props.selectedDate,
      orgUnitId: this.props.selectedTeam,
      isNightMode: this.props.isNightMode,
      createLog: this.props.createAutoAllocationLog,
    });

  startUpdates = interval => {
    this.periodicUpdate();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(this.periodicUpdate, interval);
  };

  handleClearAllocationsCancel = () => {
    this.setState({
      showClearAllocationsConfirmation: false,
    });
  };

  handleClearAllocationsConfirm = () => {
    this.setState({
      showClearAllocationsConfirmation: false,
    });
    this.props.autoUnallocate({
      date: this.props.selectedDate,
      orgUnitId: this.props.selectedTeam,
      isNightMode: this.props.isNightMode,
    });
  };

  periodicUpdate = () => {
    const { getServicesDetails } = this.props;
    getServicesDetails();
  };

  render() {
    const {
      setSorting,
      canAllocateWork,
      autoAllocationHeartBeat,
      serverDateTime,
      selectedDate,
      selectedTeam,
      teams,
      isUnAllocating,
      autoAllocationProgress,
      autoAllocationStatus,
      autoAllocationTeamName,
      autoAllocateDate,
      autoAllocateTeamId,
    } = this.props;

    const enableAutoAllocate = addDaysToDate(this.props.selectedDate, 1) > globals.now;
    const disabled = !teams || teams.length === 0;
    const autoAllocationHeartBeatTimeout =
      moment(serverDateTime).diff(moment(autoAllocationHeartBeat), 'minutes') >
      globals.consts.autoallocationHeartbeatDuration;
    return (
      <div className="filter-box">
        <div>
          {!disabled ? (
            <DropdownWrapper contentDirection="left">
              {
                <SelectableList
                  identifier="teams"
                  options={teams}
                  selectedOptions={this.getSelectedTeamOption()}
                  externalState
                  externalCallback={this.selectItem}
                />
              }
            </DropdownWrapper>
          ) : (
            <Spinner />
          )}
          <DropdownWrapper contentDirection="right">
            <SelectableList
              identifier="treatmentsSorting"
              options={sortingOptions}
              selectedOptions={this.getSelectedSortingOption()}
              externalState
              externalCallback={setSorting}
              toggleOnClick
              itemShape="name+icon"
              iconCss={styles.sorting}
              translate
            />
          </DropdownWrapper>
        </div>
        {canAllocateWork === true ? (
          <div>
            <div className="auto-allocate">
              {(autoAllocationStatus === autoAllocationStatuses.IDLE && !isUnAllocating) ||
              autoAllocationHeartBeatTimeout ? (
                <div>
                  {' '}
                  <RaisedButton
                    disabled={!enableAutoAllocate}
                    icon={autoAllocateButton}
                    label={locale.getMsg('allocateBtn')}
                    labelStyle={raisedButtonStyle.labelStyle}
                    onClick={this.autoAllocate}
                    primary
                  />
                  <RaisedButton
                    disabled={!enableAutoAllocate}
                    icon={autoUnallocateButton}
                    label={locale.getMsg('undoAllocateBtn')}
                    labelStyle={raisedButtonStyle.labelStyle}
                    onClick={this.unallocate}
                    secondary
                  />
                </div>
              ) : (
                <div style={styles.teamName}>
                  <div>{autoAllocationTeamName}</div>
                  {locale.getMsg(
                    isUnAllocating ? lowerFirstLetter('unallocating') : lowerFirstLetter(autoAllocationStatus),
                  )}
                </div>
              )}
            </div>
            <div>
              {autoAllocationStatus !== autoAllocationStatuses.IDLE &&
              !autoAllocationHeartBeatTimeout &&
              autoAllocateTeamId === selectedTeam &&
              autoAllocateDate === selectedDate ? (
                <div className="spinner-wrapper">
                  <AutoAllocateIndicator progress={autoAllocationProgress} />
                </div>
              ) : null}
              {isUnAllocating ? (
                <div className="spinner-wrapper">
                  <AutoAllocateIndicator indeterminate />
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <span />
        )}

        <ConfirmationDialog
          open={this.state.showClearAllocationsConfirmation}
          handleCancel={this.handleClearAllocationsCancel}
          handleConfirm={this.handleClearAllocationsConfirm}
          title={locale.getMsg('undoAllocateBtn')}
          text={locale.getMsg('clearAllocationsConformation')}
        />
      </div>
    );
  }
}

TreatmentFilterBox.defaultProps = {
  autoAllocationHeartBeat: 1000,
  autoAllocationTeamName: '',
  createAutoAllocationLog: false,
  autoAllocateTeamId: null,
  autoAllocateDate: '',
};

TreatmentFilterBox.propTypes = {
  setSorting: PropTypes.func.isRequired,
  sorting: PropTypes.shape({
    orderBy: PropTypes.string,
    orderDir: PropTypes.string,
  }).isRequired,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  updateFilters: PropTypes.func.isRequired,
  autoAllocate: PropTypes.func.isRequired,
  autoUnallocate: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedTeam: PropTypes.number.isRequired,
  autoAllocationStatus: PropTypes.string.isRequired,
  canAllocateWork: PropTypes.bool.isRequired,
  getServicesDetails: PropTypes.func.isRequired,
  autoAllocationProgress: PropTypes.number.isRequired,
  autoAllocationTeamName: PropTypes.string,
  isUnAllocating: PropTypes.bool.isRequired,
  serverDateTime: PropTypes.string.isRequired,
  autoAllocationHeartBeat: PropTypes.string,
  createAutoAllocationLog: PropTypes.bool.isRequired,
  syncProgress: PropTypes.number.isRequired,
  refreshScheduler: PropTypes.func.isRequired,
  autoAllocateTeamId: PropTypes.number,
  autoAllocateDate: PropTypes.string,
  isNightMode: PropTypes.bool.isRequired,
};

export default TreatmentFilterBox;
